export const DEFAULT_FIRST_FIELD_WIDTH = 170;
export const ROW_ACTION_BUTTON_WIDTH = 55;
export const SETTING_KEY_ROOT = 'grafana.explore.logs';
